import axios from 'axios';
import { API_PATH } from '../../../constants';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import createMetadataAPIActions from '../../utils/api-metadata-actions';

const options = {
  name: 'incidentFairnessPenaltyOverrides',
  baseType: 'INCIDENT_FAIRNESS_PENALTY_OVERRIDES',
  apiEndpoint: 'incident_fairness_penalty_overrides'
};

const defaultOperations = createMetadataAPIOperations(options);
const actions = createMetadataAPIActions(options);

// This is for making the API call to update the penalty that a membership has
// when the toggle is clicked
const assignOverride = (membershipId, skill_id, override_type) => dispatch => {
  const data = { override_type, skill_id };
  return axios
    .post(`${API_PATH}/memberships/${membershipId}/incident_fairness_penalty_overrides`, data)
    .then(response => dispatch(actions.fetchSuccessful(response.data, { replace: true })));
};

export default {
  ...defaultOperations,
  assignOverride
};
